import { render, staticRenderFns } from "./VendorSearchBox.vue?vue&type=template&id=c60162c8&scoped=true"
import script from "./VendorSearchBox.vue?vue&type=script&lang=js"
export * from "./VendorSearchBox.vue?vue&type=script&lang=js"
import style0 from "./VendorSearchBox.vue?vue&type=style&index=0&id=c60162c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60162c8",
  null
  
)

export default component.exports